import React from 'react';

const ProfileImage = ({ src, alt = "Profile", size = "large" }) => {
  // Tamanhos disponíveis
  const sizes = {
    small: "w-20 h-20",
    medium: "w-28 h-28",
    large: "w-32 h-32",
    xlarge: "w-40 h-40"
  };

  const sizeClass = sizes[size] || sizes.large;

  return (
    <div className="flex justify-center">
      <div className="relative group">
        {/* Borda externa com gradiente */}
        <div className={`${sizeClass} rounded-full bg-gradient-to-br from-blue-400 via-blue-700 to-blue-900 p-1 shadow-lg transition-transform duration-300 group-hover:scale-105`}>
          
          {/* Container da imagem */}
          <div className="w-full h-full rounded-full bg-white p-0.5">
            <div className="w-full h-full rounded-full overflow-hidden bg-gray-800">
              {src ? (
                <img 
                  src={src} 
                  alt={alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
              ) : (
                // Placeholder caso não tenha imagem
                <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-900">
                  <svg 
                    className="w-1/2 h-1/2 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path 
                      fillRule="evenodd" 
                      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" 
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Badge opcional - pode adicionar um status ou ícone */}
        <div className="absolute bottom-1 right-1 w-8 h-8 bg-blue-700 rounded-full border-4 border-white flex items-center justify-center shadow-md">
          <span className="text-white text-sm">✓</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileImage;